export const CONTRACTS_PAGE_CSV_HEADERS = Object.freeze({
  ID: 'ID',
  STATUS: 'Status',
  CUSTOMER: 'Customer',
  CUSTOMER_ID: 'Customer ID',
  CONTRACT: 'Contract',
  START_DATE: 'Start date',
  END_DATE: 'End date',
  DAYS_TO_END: 'Days to end',
  ESTIMATION: 'Estimation',
  SIGNATURE_DATE: 'Signature date',
  BILLING_INTERVAL: 'Billing interval',
  DURATION: 'Duration',
  AUTO_RENEWAL: 'Auto renewal',
  SYNC_STATUS: 'SO Sync',
  CURRENCY: 'Currency',
});
